import withTabs from "../../conteiners/tabs/Tabs.hoc";

const WarehouseInventory = () => {
  return <div>WarehouseInventory</div>;
};

export default withTabs({label: "Warehouse Inventory"})(WarehouseInventory);
